module.exports = __webpack_public_path__ + "img/logo_podo_row_color.ec294d8a.png";